import React, {Component} from "react";
import Moment from "moment";

import PopupAdminClassroom from "../../../Containers/PopupAdminClassroom";
import * as AdminClassroomService from "../../../../services/Teacher/AdminClassroomService";
import PagingBtn from "../../../Buttons/PagingBtn/index";

const initState = {
    isCreateClassPopupHide: true
}

class AdminManagementClassroom extends Component {
    state = {
        classroomList: [],
        isCreateClassPopupHide: true,
        sortSizeList: [
            {id: 0, text: "30개씩 보기", value: 30},
            {id: 1, text: "50개씩 보기", value: 50},
            {id: 2, text: "1000개씩 보기", value: 1000},
        ],
        sortSizeValue: 30,
        totalPages: 100,
        totalElements: 0,
        // 조회/수정/삭제 관련
        classroomNameUpdate: null,
        registerStudentList: [],
        // 수정 popup
        isUpdatePopup: false
    }

    constructor(props) {
        super(props);
        this.curPage = 0;
    }

    componentDidMount = () => {
        this.getClassroomList();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isCreateClassPopupHide == false) {
            this.getClassroomList();
            this.setState(initState);
        }
    }

    displayClassroomPopup = () => {
        this.setState({
            isCreateClassPopupHide: !this.state.isCreateClassPopupHide,
            isUpdatePopup: false
        });
    }

    displayModifyClassroomPopup = (classroom) => {
        this.setState({
            isCreateClassPopupHide: !this.state.isCreateClassPopupHide,
            isUpdatePopup: true,
            classroomNameUpdate: classroom.classroomName
        });
    }

    sortingChange = (e) => {
        this.state.sortSizeValue = e.target.value;
        this.getClassroomList();
        this.setState({
            sortSizeValue: e.target.value
        })
    }

    onUpdatePage = (page) => {
        this.curPage = page;
        this.getClassroomList();
    }

    getClassroomList = () => {
        const pageVO = {
            page: this.curPage,
            size: this.state.sortSizeValue,
            direction: 'DESC',
            sortBy: 'createdDate',
        };
        AdminClassroomService.getClassroomList(pageVO, this.searchValue).then((response) => {
            if (response !== null && response.status === 200 && response.data !== null && response.data.code === '0000') {
                this.setState({
                    classroomList: response.data.data.content,
                    totalPages: response.data.data.totalPages,
                    totalElements: response.data.data.totalElements
                });
            } else {
                alert(response.data.data);
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    // input 데이터 저장
    onInputValueChanged = (e) => {
        this.inputValue = e.target.value
    }

    // 학생 이름으로 검색
    onSearch = () => {
        if (this.inputValue == null || this.inputValue.length == 0) {
            this.searchValue = null;
        } else {
            this.searchValue = this.inputValue;
        }
        this.getClassroomList();
    }

    render() {
        return (
            <div className="wrap-rCon">
                {this.state.isUpdatePopup ?
                    <PopupAdminClassroom
                        isUpdateMod={true}
                        isLoaded={false}
                        classroomNameUpdate={this.state.classroomNameUpdate}
                        active={!this.state.isCreateClassPopupHide}
                        onClose={this.displayClassroomPopup}/>
                    : <PopupAdminClassroom isUpdateMod={false} isLoaded={false}
                                           active={!this.state.isCreateClassPopupHide}
                                           onClose={this.displayClassroomPopup}/>}
                <div className="wrap-top">
                    <a className="baseBtn undefined blue" onClick={this.displayClassroomPopup}><span>새 학급 만들기</span></a>
                    <div className="box-rfix">
                        <div className="wrap-select">
                            <span></span>
                            <select name="sortSizeValue" value={this.state.sortSizeValue} onChange={this.sortingChange}>
                                {this.state.sortSizeList.map((value, i) => {
                                    return (
                                        <option key={i} value={value.value}>{value.text}</option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="wrap-search">
                            <input className="ip-basic" type="text" placeholder="학급 이름 검색" onChange={this.onInputValueChanged}/>
                            <a className="btn-sm yellow" onClick={() => this.onSearch()}>검색</a>
                        </div>
                    </div>
                </div>

                <div className="tb-scroll">
                    <table className="tb-basic">
                        <colgroup>
                            <col width="10%"/>
                            <col width="40%"/>
                            <col width="10%"/>
                            <col width="20%"/>
                            <col width="20%"/>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>-</th>
                            <th>학급명</th>
                            <th>학생수</th>
                            <th>생성일</th>
                            <th>조회/수정/삭제</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.classroomList.map((classroom, i) =>
                            <tr key={i}>
                                <td>{classroom.id}</td>
                                <td>{classroom.classroomName}</td>
                                <td>{classroom.studentCount} 명</td>
                                <td>{Moment(classroom.createdDate).format('YYYY-MM-DD')}</td>
                                <td>
                                    <a className="btn-sm deepPink"
                                       onClick={() => this.displayModifyClassroomPopup(classroom)}>조회/수정/삭제</a>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
                <PagingBtn currentPage={this.curPage} totalPages={this.state.totalPages}
                           onUpdatePage={this.onUpdatePage}/>
            </div>
        );
    }
}

AdminManagementClassroom.defaultProps = {
    isLoadingHide: false
}

export default AdminManagementClassroom;



// WEBPACK FOOTER //
// ./src/components/Pages/Teacher/AdminManagement/Classroom.js